"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergePositions = void 0;
var abi_1 = require("@ethersproject/abi");
var ConditionalTokens_json_1 = __importDefault(require("../abi/ConditionalTokens.json"));
var types_1 = require("../types");
var encodeMerge = function (collateralTokenAddress, parentCollectionId, conditionId, partition, amount) {
    return new abi_1.Interface(ConditionalTokens_json_1.default).encodeFunctionData("mergePositions(address,bytes32,bytes32,uint256[],uint256)", [
        collateralTokenAddress,
        parentCollectionId,
        conditionId,
        partition,
        amount,
    ]);
};
var mergeTransaction = function (conditionalTokensAddress, collateralTokenAddress, parentCollectionId, conditionId, partition, amount) { return ({
    to: conditionalTokensAddress,
    typeCode: types_1.CallType.Call,
    data: encodeMerge(collateralTokenAddress, parentCollectionId, conditionId, partition, amount),
    value: "0",
}); };
exports.mergePositions = function (conditionalTokensAddress, collateralTokenAddress, 
// parentCollectionId: string,
conditionId, outcomeSlotCount, 
// partition: BigNumberish[],
amount) {
    // Assume that we're merging a condition which has been split from collateral
    var parentCollectionId = "0x" + "0".repeat(64);
    // Assume that we're mergine a full set of outcome tokens
    // eslint-disable-next-line no-bitwise
    var partition = Array.from({ length: outcomeSlotCount }, function (_, i) { return 1 << i; });
    return [
        mergeTransaction(conditionalTokensAddress, collateralTokenAddress, parentCollectionId, conditionId, partition, amount),
    ];
};
